// extracted by mini-css-extract-plugin
export var quillEditor = "_ma-1";
export var variable = "_ma-0";